import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { createManager } from 'utils/redux-injectors';
import { userPageSaga } from './saga';
import {
  UserPageState,
  DeleteUserAction,
  ActivateUserAction,
  DeactivateUserAction,
  UpdateUserStatusAction,
} from './types';

export const initialState: UserPageState = {
  loading: false,
  error: false,
};

const slice = createSlice({
  name: 'userPage',
  initialState,
  reducers: {
    activateUser: (state, action: PayloadAction<ActivateUserAction>) => {
      state.loading = true;
      state.error = false;
    },
    activateUserSucceeded: state => {
      state.loading = false;
      state.error = false;
    },
    activateUserFailed: state => {
      state.loading = false;
      state.error = true;
    },
    deactivateUser: (state, action: PayloadAction<DeactivateUserAction>) => {
      state.loading = true;
      state.error = false;
    },
    deactivateUserSucceeded: state => {
      state.loading = false;
      state.error = false;
    },
    deactivateUserFailed: state => {
      state.loading = false;
      state.error = true;
    },
    deleteUser: (state, action: PayloadAction<DeleteUserAction>) => {
      state.loading = true;
      state.error = false;
    },
    deleteUserSucceeded: state => {
      state.loading = false;
      state.error = false;
    },
    deleteUserFailed: state => {
      state.loading = false;
      state.error = true;
    },
    updateUserStatus: (
      state,
      action: PayloadAction<UpdateUserStatusAction>,
    ) => {
      // This action will be handled by the saga
    },
    cleanup: () => initialState,
  },
});

export const { actions: userPageActions, reducer: userPageReducers } = slice;

export const useUserPageSlice = () => ({ actions: slice.actions });

export const UserPageManager = createManager({
  name: `${slice.name}Manager`,
  key: slice.name,
  reducer: slice.reducer,
  saga: userPageSaga,
});
